import React, { useState, useEffect, useContext } from 'react'
import ReactDOM from 'react-dom'
import { Link } from 'gatsby'
import {
  Drawer,
  Button,
  Typography,
  IconButton,
} from '@material-tailwind/react'
import { StoreContext } from '@context/store-context'
import { useAuth0 } from '@auth0/auth0-react'
import { LineItem } from './LineItem/LineItem'
import { formatPrice } from '@utils/format-price'

import './CartDrawer.less'

export function CartDrawer() {
  const { cart, loading, showCartDrawer, setShowCartDrawer, buyNow, operationLoading } =
    useContext(StoreContext)
  const { user } = useAuth0()

  const [isBuild, setIsBuild] = useState(false)
  useEffect(() => setIsBuild(true), [])

  const closeDrawer = () => setShowCartDrawer(false)
  const handleCheckout = () => {
    buyNow(null, user?.email)
  }

  const cartLines = cart?.lines?.nodes || cart?.lines?.edges || []
  const emptyCart = cartLines.length === 0
  const subtotal = cart?.cost?.subtotalAmount
  const totalTax = cart?.cost?.totalTaxAmount
  const totalAmount = cart?.cost?.totalAmount

  const renderCartItems = () =>
    cartLines.map((item) => {
      // 处理两种数据结构：nodes直接返回item，edges需要访问node
      const lineItem = item?.node || item
      if (!lineItem) return null
      return <LineItem key={lineItem.id} item={lineItem} />
    })

  if (!isBuild) return null

  return ReactDOM.createPortal(
    <Drawer
      placement="right"
      open={showCartDrawer}
      onClose={closeDrawer}
      overlayProps={{ className: 'custom-overlay' }}
      className="p-4 cart-drawer-container l:w-full xl:w-1/2 w-2/5 flex flex-col"
      size="100%"
    >
      {/* Header */}
      <div className="cart-drawer-title mb-6 flex items-center justify-between">
        <Typography variant="h5" color="blue-gray">
          Shopping cart
        </Typography>
        <IconButton variant="text" color="blue-gray" onClick={closeDrawer}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="h-5 w-5"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </IconButton>
      </div>

      {/* Content */}
      <div className="cart-drawer-content flex-1 overflow-y-auto max-h-[calc(100vh-200px)]">
        {emptyCart ? (
          <div className="empty-state-container">
            <h1 className="empty-state-heading">Your cart is empty</h1>
            <p className="text-sm text-gray-600">
              Looks like you haven't found anything yet.
            </p>
            <Link to="/search?s=BEST_SELLING" className="empty-state-link">
              View trending products
            </Link>
          </div>
        ) : (
          <ul className="-my-6 divide-y divide-gray-200">
            {renderCartItems()}
          </ul>
        )}
      </div>

      {/* Footer */}
      {!emptyCart && (
        <div className="cart-drawer-footer border-t border-gray-200 px-4 py-6 mt-6 sm:px-6">
          <div className="flex justify-between text-base font-medium text-gray-900">
            <p>Subtotal</p>
            <p>
              {subtotal
                ? formatPrice(subtotal.currencyCode, subtotal.amount)
                : '-'}
            </p>
          </div>

          <div className="flex justify-between text-sm text-gray-600">
            <p>Taxes</p>
            <p>
              {totalTax
                ? formatPrice(totalTax.currencyCode, totalTax.amount)
                : 'Calculated at checkout'}
            </p>
          </div>

          <div className="flex justify-between text-lg font-bold text-gray-900 border-t border-gray-200 pt-2 mt-2">
            <p>Total</p>
            <p>
              {totalAmount
                ? formatPrice(totalAmount.currencyCode, totalAmount.amount)
                : '-'}
            </p>
          </div>

          <p className="mt-0.5 text-sm text-gray-500">
            Shipping calculated at checkout.
          </p>

          <Button
            onClick={handleCheckout}
            className="flex items-center w-full mt-6 justify-center rounded-md border border-transparent bg-indigo-600 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-indigo-700"
            disabled={operationLoading.checkout}
            loading={operationLoading.checkout}
          >
            Checkout
          </Button>

          <div className="mt-6 flex justify-center text-sm text-gray-500">
            <button
              type="button"
              className="font-medium text-indigo-600 hover:text-indigo-500 ml-1"
              onClick={closeDrawer}
            >
              Continue Shopping <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>
      )}
    </Drawer>,
    document.body,
  )
}
